import axios from '@_system/axios/axios.js'
export default {
	path: '/material',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listgoodstype(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listgoodstype', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listgoodssku(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listgoodssku', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getspucode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getspucode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getskucode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getskucode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	addMaterial(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/addMaterial', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getMaterial(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getMaterial', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	batchAction(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/batchAction', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/material.material', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
